import React from 'react';

import { useDropdownContext } from './dropdownContext';

const DropdownLink = ({ title, path }) => {
  const { toggleOpen } = useDropdownContext();

  return (
    <a
      href={path}
      className="dropdown__menu__item__link"
      onClick={() => toggleOpen(false)}
    >
      {title}
    </a>
  );
};

export default DropdownLink;
